import { Divider, MenuItem, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';

import { StyledDropdown, StyledPagination } from './grid.styles';
import type { TPhoenixTable } from './utility/types';

interface IGridPaginationProps {
    table: TPhoenixTable;
    paginationIconBgColor: string;
    paginationIconColor: string;
    rowsPerPageOptions?: number[];
}

export const GridPagination = ({
    table,
    paginationIconBgColor,
    paginationIconColor,
    rowsPerPageOptions,
}: IGridPaginationProps) => {

    const { pageIndex, pageSize } = table.state.pagination;
    const pageCount = table.getPageCount();
    const pageNumber = useMemo(
        () => (pageCount < 1 ? 0 : pageIndex + 1),
        [pageCount, pageIndex]
    );
    return (
        <Stack spacing={2} direction="row" alignItems="center">

            {rowsPerPageOptions && rowsPerPageOptions.length > 1 && (
                <>
                    <StyledDropdown
                        value={pageSize}
                        onChange={(event) =>
                            table.setPageSize(Number(event.target.value))
                        }
                        style={{ cursor: 'pointer' }}
                    >
                        {rowsPerPageOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </StyledDropdown>

                    <Divider flexItem orientation="vertical" />
                </>
            )}
            <Typography variant="subtitle2">
                Page: {pageNumber} of {pageCount}
            </Typography>
            <Divider flexItem orientation="vertical" />
            <StyledPagination
                showFirstButton
                showLastButton
                size="small"
                $paginationIconBgColor={paginationIconBgColor}
                $paginationIconColor={paginationIconColor}
                count={pageCount}
                page={pageNumber}
                disabled={pageCount === 0}
                onChange={(_event, value) =>
                    table.setPageIndex(value - 1)
                }
            />
        </Stack>
    );
};